import React from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../component/NavBar';

const HomePage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-900 via-indigo-800 to-blue-900 flex flex-col">
      <Navbar className="p-4"/>
      <div className="flex-grow container mx-auto px-4 py-8">
        {/* Hero Section */}
        <div className="text-center mb-12">
          <h1 className="text-5xl font-bold text-white mb-4">Truth or Dare</h1>
          <p className="text-xl text-gray-200 mb-8">Play the classic party game online with friends!</p>
        </div>

        {/* Game Card */}
        <div className="max-w-4xl mx-auto">
          <div className="bg-white/10 backdrop-blur-lg rounded-2xl p-8 shadow-2xl border border-white/20">
            <div className="grid md:grid-cols-2 gap-8">
              {/* Game Button */}
              <div className="flex items-center justify-center">
                <button
                  onClick={() => navigate('/truthdare')}
                  className="bg-gradient-to-r from-pink-500 via-purple-500 to-indigo-500 hover:from-pink-600 hover:via-purple-600 hover:to-indigo-600 text-white text-2xl font-bold py-6 px-12 rounded-xl shadow-lg transition-all duration-300 transform hover:scale-105 hover:shadow-xl"
                >
                  Play Now
                </button>
              </div>

              {/* Quick Instructions */}
              <div className="text-white">
                <h2 className="text-2xl font-bold mb-4">How to Play</h2>
                <ul className="space-y-3 text-gray-200">
                  <li className="flex items-start">
                    <span className="text-pink-400 mr-2">•</span>
                    Choose between Truth or Dare on your turn
                  </li>
                  <li className="flex items-start">
                    <span className="text-purple-400 mr-2">•</span>
                    Answer truthfully or complete the dare
                  </li>
                  <li className="flex items-start">
                    <span className="text-indigo-400 mr-2">•</span>
                    Keep it fun and respectful!
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Detailed Instructions */}
          <div className="mt-12 bg-white/5 backdrop-blur-lg rounded-2xl p-8 shadow-xl border border-white/10">
            <h2 className="text-2xl font-bold text-white mb-6">Game Rules</h2>
            <div className="grid md:grid-cols-2 gap-6 text-gray-200">
              <div>
                <h3 className="text-xl font-semibold text-pink-400 mb-3">Getting Started</h3>
                <ul className="space-y-2">
                  <li>• Gather 4-8 players</li>
                  <li>• Set your comfort boundaries</li>
                  <li>• Take turns in order</li>
                </ul>
              </div>
              <div>
                <h3 className="text-xl font-semibold text-purple-400 mb-3">During Play</h3>
                <ul className="space-y-2">
                  <li>• Choose Truth or Dare</li>
                  <li>• Answer honestly or complete the dare</li>
                  <li>• Respect others' boundaries</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
